"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERSION = void 0;
exports["abstract"] = _abstract;
exports.getUid = getUid;

/**
 * @module ol/util
 */

/**
 * @return {?} Any return.
 */
function _abstract() {
  return (
    /** @type {?} */
    function () {
      throw new Error('Unimplemented abstract method.');
    }()
  );
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */


var uidCounter_ = 0;
/**
 * Gets a unique ID for an object. This mutates the object so that further calls
 * with the same object as a parameter returns the same value. Unique IDs are generated
 * as a strictly increasing sequence. Adapted from goog.getUid.
 *
 * @param {Object} obj The object to get the unique ID for.
 * @return {string} The unique ID for the object.
 * @api
 */

function getUid(obj) {
  return obj.ol_uid || (obj.ol_uid = String(++uidCounter_));
}
/**
 * OpenLayers version.
 * @type {string}
 */


var VERSION = '6.14.1';
exports.VERSION = VERSION;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7Ozs7QUFJQTs7O0FBR00sU0FBVUEsU0FBVixHQUFrQjtFQUN0QjtJQUFPO0lBQ0o7TUFDQyxNQUFNLElBQUlDLEtBQUosQ0FBVSxnQ0FBVixDQUFOO0lBQ0QsQ0FGRDtFQURGO0FBS0Q7QUFFRDs7Ozs7OztBQUtBLElBQUlDLFdBQVcsR0FBRyxDQUFsQjtBQUVBOzs7Ozs7Ozs7O0FBU00sU0FBVUMsTUFBVixDQUFpQkMsR0FBakIsRUFBb0I7RUFDeEIsT0FBT0EsR0FBRyxDQUFDQyxNQUFKLEtBQWVELEdBQUcsQ0FBQ0MsTUFBSixHQUFhQyxNQUFNLENBQUMsRUFBRUosV0FBSCxDQUFsQyxDQUFQO0FBQ0Q7QUFFRDs7Ozs7O0FBSU8sSUFBTUssT0FBTyxHQUFHLFFBQWhCIiwibmFtZXMiOlsiYWJzdHJhY3QiLCJFcnJvciIsInVpZENvdW50ZXJfIiwiZ2V0VWlkIiwib2JqIiwib2xfdWlkIiwiU3RyaW5nIiwiVkVSU0lPTiJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcmMvdXRpbC5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==